export enum RaffleRewardClaimStatusEnum {
  WAITING_REQUEST = "w",
  REQUESTED = "r",
  APPROVED = "a",
  PENDING_INFORMATION = "p",
  SENT = "s",
  DELIVERED = "d",
  QUESTIONED = "q",
  CANCELED = "c",
  EXCLUDED = "x",
}

export type RaffleRewardClaimStatusTypes =
  `${RaffleRewardClaimStatusEnum}`;

export enum RaffleRewardClaimDeliveryTypeEnum {
  SHIPPING = "shipping",
  PIX = "pix",
  BANK = "bank",
  PICKUP = "pickup",
  DIGITAL = "digital",
  MANUAL = "manual",
  OTHER = "other",
}

export type RaffleRewardClaimDeliveryTypes =
  `${RaffleRewardClaimDeliveryTypeEnum}`;
